
import { Tilelet } from "@vds/tiles";
import { Title } from '@vds/typography';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import cruiseDesktop from '../../assets/images/cruise_desktop.png';
import cruiseMobile from '../../assets/images/cruise_mobile.png';
import cruiseTablet from '../../assets/images/cruise_tablet.png';
import inflightDesktop from '../../assets/images/inflight_desktop.png';
import inflightMobile from '../../assets/images/inflight_mobile.png';
import inflightTablet from '../../assets/images/inflight_tablet.png';
import { useGetDevicesAndPlansByNameQuery } from '../../features/devicesAndPlans/devicesAndPlansFetch';
import { updateCart } from '../../features/devicesAndPlans/updatePlans';
import { saveConfirmedPlanData, savePlanEffectiveDate } from '../../features/selectedData/persistantDataReducer';
import { saveFailedPlanData } from '../../features/selectedData/selectedDataReducer';
import ReviewModal from '../../pages/ITP/ReviewModal';
import Footer from '../../shared/components/Footer';
import { GetSelectedDeviceDetails } from "../../shared/components/GetPlanPageDetails.jsx";
import FullPageLoader from '../../shared/components/Loader';
import { isDesktop, isTab } from '../../shared/utils/globalConfig';
import { getDestList, getErrorMessage,getDevicesPayload } from '../../shared/utils/globalUtils';
import { dispatchPageView } from '../../shared/utils/tagging';
import { unauth } from '../../shared/utils/globalConfig';

const SkipNewPlanMain = styled.div`
`
const Space = styled.div`
padding-top: 24px;
`

const TileletGrp = styled.div`
display: ${isDesktop ? 'flex' : ''};
gap: 16px;
`

export default function SkipNewPlan() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { selectedDestinations, selectedDates, confirmedPlanData ,selectedDeviceDetailsUnauth} = useSelector(state => state?.persistantReducer);
    const { planUpdatedData, failedUpdateCartData, selectedDeviceDetails } = useSelector(state => state?.selectedReducer);
    
    const imageUrl = window.appConfig?.reactStaticFilePathNsa + 'assets/images/';
   
    const getDevicesPayloadUnauths = () => {
        let payloads = {
            'destinationSelected': getDestList(selectedDestinations, 'key'),
            "travelStartDate": selectedDates?.travelStartDate,
            "travelEndDate": selectedDates?.travelEndDate,
            "unAuthflow": true,
            "deviceNickName": selectedDeviceDetailsUnauth?.deviceDisplayName,
            "deviceImageUrl": selectedDeviceDetailsUnauth?.deviceImageUrl,
            "skuId": selectedDeviceDetailsUnauth?.skuId,
            "brandName": selectedDeviceDetailsUnauth?.brandName,
        }
        return payloads;
    }


    const Payload = unauth ? getDevicesPayloadUnauths() : getDevicesPayload(selectedDates,selectedDestinations);
    const { data, error, isLoading, isSuccess } = useGetDevicesAndPlansByNameQuery(Payload)
    const [skipCruiseFlightObject, setSkipCruiseFlightObject] = useState();
    const [showLoader, setShowLoader] = useState(false);


    useEffect(() => {
        setSkipCruiseFlightObject(data?.body?.data?.skipCruiseAndFlightPlans);
    }, [data]);

    useEffect(() => {
         if (Object.keys(selectedDeviceDetails).length === 0) {
            navigate(-1, { replace: true })
        }
    }, [selectedDeviceDetails])

    //Tagging
    useEffect(() => {
        dispatchPageView('ITP_SkipNewPlan', 'Skip new plan', '#skip_plan');
    }, [])

    const [showReviewModal, setReviewModal] = useState(false);
    const [reviewPageData, setReviewPageData] = useState();

    const OnTiletClick = (planName) => {
        // for inflightplan reviewdetails modal will be outside planinfo due to scenario M

        if (planName === 'In-flight Daily Pass') {
            setReviewModal(true)
            setReviewPageData(data?.body?.data?.inFlightReviewDetailObject)
        }
        else {
            unauth? navigate("/uaitpcruiseplan", { replace: true }) : navigate("/itpcruiseplanselection", { replace: true });
        }
    }


    const updateCartFromSkip = (planDetails) => {
        setShowLoader(true);
        let payloadcart = {
            'mtn': planDetails?.mtn,
            'features': planDetails?.featuresCart,
            'effectiveDate': planDetails?.effectiveDate
        }
        let response = updateCart(payloadcart);
        response.then(res => {
            if (res?.data?.responseInfo?.responseCode == 0) {
                let updatedPlanData = JSON.parse(JSON.stringify(planDetails));
                let seaPlan = selectedDeviceDetails.currentPlanDetails.filter(plan => plan.planType === 'sea')
                if (seaPlan.length > 0) {
                    let [plan] = seaPlan;
                    let currentFeature = {
                        "currentPlanId": plan?.planId,
                        "newPlanId": '',
                        "currentPlanCategory": plan?.category,
                        "newPlanCategory": '',
                        "currentPlanName": '',
                        "newPlanName": plan.planName,
                        "planType": plan?.planType,
                        "quantity": "1"
                    }
                    let updatedseaplans = {
                        "planName": plan?.planName,
                        "planCost": plan?.planCost,
                        "planType": plan?.planType,
                        "currentPlan": true
                    }
                    updatedPlanData?.featuresConfirm.push(currentFeature);
                    updatedPlanData?.updatedPlanDetails.push(updatedseaplans);
                }
                if (updatedPlanData?.updatedPlanDetails.find((plan) => plan.currentPlan === false)) {
                    let updatedplans = [...confirmedPlanData, updatedPlanData];
                    if (updatedPlanData?.effectiveDate) {
                        const updateEffectiveDateObj = JSON.parse(JSON.stringify(updatedplans)).map((plan) => {
                            if (plan?.effectiveDate) {
                                plan.effectiveDate = planDetails?.effectiveDate
                            }
                            return plan;
                        })

                        updatedplans = updateEffectiveDateObj;
                    }
                    dispatch(savePlanEffectiveDate(planDetails?.effectiveDate));
                    dispatch(saveConfirmedPlanData(updatedplans));
                }
            } else {
                const { title, message } = getErrorMessage(res);
                let errorSkipPlanData = JSON.parse(JSON.stringify(planDetails));
                errorSkipPlanData['errorTitle'] = title?.itemValue;
                errorSkipPlanData['errorMessage'] = message?.itemValue;
                dispatch(saveFailedPlanData([...failedUpdateCartData, errorSkipPlanData]));
            }
            setShowLoader(false);
            navigate(-1, { replace: true })

        }).catch(err => {
            const { title, message } = getErrorMessage(err?.response)
            let errSkipPlanData = JSON.parse(JSON.stringify(planDetails));
            errSkipPlanData['errorTitle'] = title?.itemValue;
            errSkipPlanData['errorMessage'] = message?.itemValue;
            dispatch(saveFailedPlanData([...failedUpdateCartData, errSkipPlanData]));
            setShowLoader(false);
            navigate(-1, { replace: true })
        })
    }
    const redirectUaaSummary = (planDetails) => {
        let updatedPlans = [...confirmedPlanData, planDetails];
        dispatch(saveConfirmedPlanData(updatedPlans));
        navigate("/uasummary", { replace: true });
    }
    const skipClickHandle = () => {
        if (planUpdatedData?.featuresCart?.length > 0) {
           updateCartFromSkip(planUpdatedData);
        }else if (planUpdatedData?.features?.length > 0) {
            redirectUaaSummary(planUpdatedData);
        }
         else {
            navigate(-1, { replace: true });
        }

    }

    return (
        <SkipNewPlanMain id="skip_plan">
            <GetSelectedDeviceDetails planType='skip'/>
            <Space></Space>
            <Title data-testid="availabletextId" size="XLarge">{skipCruiseFlightObject?.alsoAvailableText}</Title>
            <Space></Space>
            {skipCruiseFlightObject?.skipPlanObject &&
                <TileletGrp>
                    <Tilelet
                        viewport="mobile"
                        title={{
                            bold: false,
                            size: 'titleMedium',
                            children: skipCruiseFlightObject?.skipPlanObject[0].planName,
                        }}
                        subtitle={{
                            size: 'bodyLarge',
                            children: skipCruiseFlightObject?.skipPlanObject[0].planDesc,
                            color: 'secondary'
                        }}
                        directionalIcon={{
                            name: 'right-arrow',
                            size: 'medium'
                        }}
                        surface='light'
                        width={isDesktop ? '45%' : '100%'}
                        height={isDesktop ? '300px' : '185px'}
                        onClick={() => { OnTiletClick(skipCruiseFlightObject?.skipPlanObject[0].planName) }}
                        backgroundColor='black'
                        backgroundImage={skipCruiseFlightObject?.skipPlanObject[0].imageurl}
                    />
                    <Space></Space>
                    <Tilelet
                        viewport="mobile"
                        title={{
                            bold: false,
                            size: 'titleMedium',
                            children: skipCruiseFlightObject?.skipPlanObject[1].planName,
                        }}
                        subtitle={{
                            size: 'bodyLarge',
                            children: skipCruiseFlightObject?.skipPlanObject[1].planDesc,
                            color: 'secondary'
                        }}
                        directionalIcon={{
                            name: 'right-arrow',
                            size: 'medium'
                        }}
                        surface='light'
                        width={isDesktop ? '45%' : '100%'}
                        height={isDesktop ? '300px' : '185px'}
                        backgroundImage={skipCruiseFlightObject?.skipPlanObject[1].imageurl}
                        onClick={() => { OnTiletClick(skipCruiseFlightObject?.skipPlanObject[1].planName) }}
                    />
                </TileletGrp>
            }

            <Space></Space>
            <Footer ctaLabel={skipCruiseFlightObject?.skipButtonText} disabled={false} handleButtonChange={() => skipClickHandle()} btnType="secondary">
            </Footer>

            {showReviewModal &&
                <ReviewModal
                    setReviewModal={setReviewModal}
                    showReviewModal={showReviewModal}
                    PlanData={reviewPageData}
                />
            }
            {showLoader && <FullPageLoader />}
        </SkipNewPlanMain>
    );
}